import { getConversationThreadQueryOptions } from "@/api/get-conversation";
import type { Conversation } from "@rulebase/core/api";
import { useQuery } from "@tanstack/react-query";

/**
 * Whether this ticket has any linked activity to show. The ticket params row
 * needs this to decide whether to offer the show/hide toggle at all; React
 * Query serves it from the same cache entry the list itself reads. Until the
 * thread loads (or if it fails) there is nothing to toggle.
 */
export function useHasLinkedActivity(conversation: Conversation): boolean {
  const { data } = useQuery(getConversationThreadQueryOptions(conversation.id));

  return (data?.data?.items?.length ?? 0) > 0;
}
